<script setup>
import {
  toRefs,
  computed,
} from 'vue';
import {
  useRoute,
  RouterLink,
} from 'vue-router';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  to: {
    type: Object,
    default: () => ({}),
  },
  className: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['clickEvent']);
const { to } = toRefs(props);

const clickEvent = () => {
  emit('clickEvent');
};

const route = useRoute();
const { t } = useI18n();

const path = computed(() => to.value.path);

</script>
<template>
  <RouterLink
    :to="to"
    :class="{
      'nav__text--active': route.path === path,
      [className]: true,
    }"
    @click="clickEvent"
  >
    <i></i><span>{{ t(title) }}</span>
  </RouterLink>
</template>
